import { redactSensitiveString, safeStringifyRedacted } from '../security/redaction';

export function redactSensitiveValue(value: unknown): string {
  return typeof value === 'string' ? redactSensitiveString(value) : safeStringifyRedacted(value);
}

export function stripHashFromUrl(value: string): string {
  const hashIndex = value.indexOf('#');
  return hashIndex >= 0 ? value.slice(0, hashIndex) : value;
}

export type PublicLogger = {
  info(message: string, context?: unknown): void;
  warn(message: string, context?: unknown): void;
  error(message: string, context?: unknown): void;
};

export function createPublicLogger(prefix = 'quaom-public'): PublicLogger {
  const write = (level: 'info' | 'warn' | 'error', message: string, context?: unknown) => {
    const formatted = `[${prefix}] ${message}`;
    if (context === undefined) {
      console[level](formatted);
      return;
    }
    console[level](formatted, redactSensitiveValue(context));
  };

  return {
    info: (message, context) => write('info', message, context),
    warn: (message, context) => write('warn', message, context),
    error: (message, context) => write('error', message, context),
  };
}
